<template>
    <!--Web View-->
    <v-card min-width="230" max-width="235" min-height="320" max-height="350"
        class="ma-3 rounded-xl d-none d-sm-block d-md-block d-lg-block" elevation="0" color="#fff"
        v-for="product in products" :key="product.id">

        <v-card class="float-right  mr-0 mb-n5" color="primary" elevation="0" rounded="0">
            <v-btn color="white" variant="plain" size="small" v-if="product.organic">
                <v-icon color="white">mdi-leaf-circle</v-icon>&nbsp;
                Organic
            </v-btn>
        </v-card>

        <v-img height="100" width="100" class="mx-auto mt-3" :src="product.image"></v-img>
        <v-card-item class="text-left">
            <v-card-title class="text-wrap text-subtitle-2 font-weight-bold product-title"
                v-if="!product.description">{{
            product.name }}</v-card-title>
            <div class="text-center" v-if="product.description">
                <v-menu location="end">
                    <template v-slot:activator="{ props }">
                        <v-card-title class="text-wrap text-subtitle-2 font-weight-bold product-title" v-bind="props">
                            {{ product.name }} <v-icon color="black">mdi-chevron-right</v-icon>
                        </v-card-title>
                    </template>
                    <v-card min-width="280" max-width="280" rounded="lg">
                        <v-img :src="product.image" height="150" class="mx-auto mt-3">
                        </v-img>
                        <v-card-title class="text-black web-text text-center">
                            {{ product.name }}
                        </v-card-title>
                        <v-divider class="ma-1"></v-divider>
                        <v-card-text class="ml-3">
                            <div v-html="product.description"></div>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </div>
        </v-card-item>

        <v-divider class="mx-4 mb-1"></v-divider>
        <div class="px-4">
            <v-chip-group v-model="product.unitSelected" selected-class="text-green-darken-4" mandatory column>
                <v-chip v-for="unit in product.unit" :key="unit.unit_id" :value="unit.unit_id"
                    @click="productUnitSelect(product, unit)" class="web-chip-text">{{ unit.unit_name }}</v-chip>
            </v-chip-group>
        </div>
        <v-card-actions class="mb-1 product-card-actions">
            <v-btn variant="text" size="small" min-width="80" min-height="30" class="text-center"
                v-if="product.priceSelected">
                <p class="text-primary price-text">Rs.
                    {{ product.priceSelected }}</p>
            </v-btn>
            <template v-if="BrandAddOn == true || product.addon == '0'">
                <div v-if="locationDetails.sale == true">
                    <template v-if="(product.unit).length != '0'">
                        <v-btn color="primary" rounded variant="flat" size="small" min-width="70" min-height="30"
                            class="text-center" @click="productAdd(product)" v-if="product.qty == 0">
                            <p class="text-white">ADD</p>
                        </v-btn>
                        <div v-if="product.qty > 0">
                            <v-btn size="24" variant="flat" color="primary" icon @click="decrement(product)">
                                <v-icon color="white" size="14">mdi-minus</v-icon>
                            </v-btn>
                            <span class="text-black ml-2">
                                <!-- {{ product.qty}} -->
                                <input type="number" v-model="product.proqty" class="product-web-textbox" @keyup="productqty(product)" >
                            </span>
                            <v-btn size="24" variant="flat" color="primary" icon @click="increment(product)">
                                <v-icon color="white" size="14">mdi-plus</v-icon>
                            </v-btn>
                        </div>
                    </template>
                    <template v-else>
                        <v-btn color="orange" rounded variant="tonal" size="small" min-width="70" min-height="30" class="text-center">
                            <p class="text-black">Sold Out</p>
                        </v-btn>
                    </template>
                </div>
            </template>
            <template v-else>
                <v-btn color="lime-darken-3" rounded variant="flat" size="small" min-width="70" min-height="30" class="text-center" disabled> 
                    <p class="text-white">ADD</p>
                </v-btn>
            </template>
        </v-card-actions>
    </v-card>
    <!--Web View End-->

    <!--Mobile View Start-->

    <v-card min-width="155" max-width="155" min-height="280"
        class="ma-2 mb-2 mr-auto rounded-xl d-block d-sm-none d-md-none d-lg-none" elevation="0" color="#fff"
        v-for="product in products" :key="product.id">
        <v-card class="float-right mr-0 mb-n1 mobile-product-title" color="primary" elevation="0" rounded="0">
            <v-btn color="white" variant="plain" size="small" v-if="product.organic">
                <v-icon color="white">mdi-leaf-circle</v-icon>&nbsp;
                Organic
            </v-btn>
        </v-card>
        <v-img height="75" width="75" class="mx-auto mt-2" :src="product.image"></v-img>

        <v-card-item class="text-left">
            <v-card-title class="text-wrap font-weight-bold mobile-product-title" v-if="!product.description">{{
            product.name }}</v-card-title>

            <div class="text-center" v-if="product.description">
                <v-menu location="end">
                    <template v-slot:activator="{ props }">
                        <v-card-title class="text-wrap font-weight-bold mobile-product-title" v-bind="props">
                            {{ product.name }} <v-icon color="black">mdi-chevron-right</v-icon>
                        </v-card-title>
                    </template>
                    <v-card min-width="250" max-width="250" rounded="lg">
                        <v-img :src="product.image" height="120" class="mx-auto mt-3">
                        </v-img>
                        <v-card-title class="text-black web-text text-center">
                            {{ product.name }}
                        </v-card-title>
                        <v-divider class="ma-1"></v-divider>
                        <v-card-text class="ml-3">
                            <div v-html="product.description"></div>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </div>
            <!--<v-card-subtitle class="text-left text-wrap"  v-if="product.priceSelected">
           <span class="text-black font-weight-black me-1">Rs.{{ product.priceSelected }}</span>
            </v-card-subtitle>-->
        </v-card-item>
        <v-divider class="mx-4 mb-1"></v-divider>
        <div class="px-1">
            <v-chip-group v-model="product.unitSelected" selected-class="text-green-darken-4" mandatory column>
                <v-chip v-for="unit in product.unit" :key="unit.unit_id" :value="unit.unit_id"
                    @click="productUnitSelect(product, unit)" class="mobile-chip-text">{{
            unit.unit_name }}</v-chip>
            </v-chip-group>
        </div>
        <v-card-actions class="mb-1 product-card-actions">
            <v-btn variant="text" size="small" min-width="75" min-height="30" class="text-center"
                v-if="product.priceSelected">
                <p class="text-primary price-text">Rs.{{
            product.priceSelected }}</p>
            </v-btn>

            <template v-if="BrandAddOn == true || product.addon == '0'">
                <div v-if="locationDetails.sale == true">
                    <template v-if="(product.unit).length != '0'">
                        <v-btn color="primary" rounded variant="flat" size="small" min-height="30" class="text-center"
                            @click="productAdd(product)" v-if="product.qty == 0">
                            <p class="text-white">ADD</p>
                        </v-btn>
                        <div v-if="product.qty > 0">
                            <v-btn size="15" variant="flat" color="primary" icon @click="decrement(product)">
                                <v-icon color="white" size="12">mdi-minus</v-icon>
                            </v-btn>
                            <span class="text-black mobile-qty">
                                <!-- {{ product.qty }} -->
                                <input v-model="product.proqty" class="product-mobile-textbox" @keyup="productqty(product)" >
                            </span>
                            <v-btn size="15" variant="flat" color="primary" icon @click="increment(product)" class="product-mobile-buttonplus">
                                <v-icon color="white" size="12">mdi-plus</v-icon>
                            </v-btn>
                        </div>
                    </template>
                    <template v-else>
                        <v-btn color="orange" rounded variant="tonal" size="small" min-height="30" class="text-center">
                            <p class="text-black">Sold Out</p>
                        </v-btn>
                    </template>
                </div>
            </template>
            <template v-else>
                <v-btn color="lime-darken-3" rounded variant="flat" size="small" min-height="30" class="text-center" disabled> 
                    <p class="text-white">ADD</p>
                </v-btn>
            </template>

        </v-card-actions>
    </v-card>

    <!--Mobile View End-->
    <!--Footer Start-->
    <v-snackbar v-model="stocksnackbar" :timeout="timeout" class="mb-10">
        {{ stocksnackbartext }}
    </v-snackbar>
</template>

<style>
.web-chip-text {
    font-size: 12px !important;
}

.mobile-chip-text {
    font-size: 10px !important;
}

.price-text {
    letter-spacing: 0px !important;
}

.product-card-actions {
    bottom: 0 !important;
    position: absolute;
}

.mobile-qty {
    font-size: 12px !important;
}

.mobile-product-title {
    font-size: 12px !important;
    line-height: 1.2rem !important;
}

.product-title {
    line-height: 1.2rem !important;
}

.product-web-textbox{
    width: 60px;
    background: #c3bebe7d;
    border-radius: 15px;
    text-align: center;
    font-size: 13px;
}

.product-mobile-textbox{
    width: 32px;
    background: #c3bebe7d;
    border-radius: 15px;
    text-align: center;
    font-size: 11px;
}

.product-mobile-buttonplus{
    margin: 0 !important;
}

</style>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    name: 'ProductCard',
    data: () => ({
        stocksnackbar: false,
        stocksnackbartext: '',
        timeout: 2000,
    }),
    props: {
        products: Array
    },
    created() {
        this.getlocationDetails();
    },
    computed: {
        ...mapGetters([
            "locationDetails",
            "BrandAddOn",
        ]),
    },
    methods: {
        ...mapActions([
            "getlocationDetails",
            "addTocart",
        ]),
        productUnitSelect(product, unit) {
            product.unitSelected = unit.unit_id;
            product.priceSelected = unit.unit_price;
            product.unitValueSelected = unit.unit_value;
            product.qty = unit.unit_qty;
            product.proqty = unit.unit_qty;
            product.max_order_qty = unit.max_order_qty;
            //console.log(product);

        },
        productAdd(product) {
            product.qty = 1;
            product.proqty = product.qty
            //console.log(product);
            this.addTocart(product);
        },

        increment(product) {

            if (product.qty < product.max_order_qty) {
                product.qty = product.qty === product.max_order_qty ? product.max_order_qty : product.qty + 1;
                product.unit.filter(function (unit) {
                    return unit.unit_id === product.unitSelected;
                }).map(function (unit) {
                    return unit.unit_qty = product.qty;
                })
                product.proqty = product.qty
                this.addTocart(product);
            }
            else {
                //console.log(product.max_order_qty);
                product.qty = product.max_order_qty;
                product.unit.filter(function (unit) {
                    return unit.unit_id === product.unitSelected;
                }).map(function (unit) {
                    return unit.unit_qty = product.qty;
                })
                product.proqty = product.qty
                this.addTocart(product);
                this.stocksnackbartext = product.name + ' reached maximum order qty';
                this.stocksnackbar = true;
            }

        },
        decrement(product) {
            if (product.qty <= product.max_order_qty) {
                // console.log('1');
                product.qty = product.qty === 0 ? 0 : product.qty - 1;
                //qty update for unit
                product.unit.filter(function (unit) {
                    return unit.unit_id === product.unitSelected;
                }).map(function (unit) {
                    return unit.unit_qty = product.qty;
                })
                product.proqty = product.qty
                this.addTocart(product);
            }
            else {

                product.qty = product.max_order_qty;
                product.unit.filter(function (unit) {
                    return unit.unit_id === product.unitSelected;
                }).map(function (unit) {
                    return unit.unit_qty = product.qty;
                })
                product.proqty = product.qty
                this.addTocart(product);
                // console.log('2');
            }
        },

        productqty(product)
        {
            if(product.proqty != '' && product.proqty != null)
            {
                if (product.proqty <= product.max_order_qty) {
                    product.qty = product.proqty
                } else {
                    product.proqty = product.max_order_qty;
                    product.qty = product.max_order_qty;
                    this.stocksnackbartext = product.name + ' reached maximum order qty';
                    this.stocksnackbar = true;
                }

                product.unit.filter(function (unit) {
                    return unit.unit_id === product.unitSelected;
                }).map(function (unit) {
                    return unit.unit_qty = product.qty;
                })

                this.addTocart(product);
            } else {
                if(product.proqty == '0')
                {
                    product.qty = product.proqty
                    product.unit.filter(function (unit) {
                        return unit.unit_id === product.unitSelected;
                    }).map(function (unit) {
                        return unit.unit_qty = product.qty;
                    })

                    this.addTocart(product);
                }
            }
        },
    },

}
</script>